// Userflow triggers our UI through hash links, because its "Evaluate JavaScript" action needs
// unsafe-eval that our CSP denies. The hash keeps the current page and its query intact, so a
// single link works from anywhere — e.g. `#openInfraAssistant`, `#revealSidebarPin=launchpad`.
export const URL_HASH_OPEN_INFRA_ASSISTANT_KEY = "openInfraAssistant";
export const URL_HASH_REVEAL_SIDEBAR_PIN_KEY = "revealSidebarPin";
